module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section section-white content-padded view-flex view-flex-middle"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('el-switch', {
    staticClass: "content-right-margin",
    attrs: {
      "active-color": "#ff5000",
      "inactive-text": "买单"
    },
    model: {
      value: (_vm.settings.pay),
      callback: function($$v) {
        _vm.$set(_vm.settings, "pay", $$v)
      },
      expression: "settings.pay"
    }
  }), _vm._v(" "), _c('el-switch', {
    staticClass: "content-right-margin",
    attrs: {
      "active-color": "#ff5000",
      "inactive-text": "储值"
    },
    model: {
      value: (_vm.settings.recharge),
      callback: function($$v) {
        _vm.$set(_vm.settings, "recharge", $$v)
      },
      expression: "settings.recharge"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "section-white view-warp"
  }, [_c('div', {
    staticClass: "template-view"
  }, [_c('div', {
    staticClass: "template",
    style: ('background:' + _vm.theme.bodyColor)
  }, [_c('div', {
    staticClass: "template-header",
    style: ('background:' + _vm.theme.bgColor + ' url(' + _vm.headerBg + ') no-repeat 0 4px; background-size: 100% auto;')
  }, [_c('div', {
    staticClass: "template-title",
    style: ('color:' + _vm.theme.fontColor)
  }, [_vm._v("标题")])]), _vm._v(" "), _c('div', {
    staticClass: "member-header"
  }, [_c('div', {
    staticClass: "view-flex view-flex-justify view-flex-vertical member-card",
    style: ('background: #efefef url(' + _vm.demoimg + '); background-size: cover')
  }, [_c('div', {
    staticClass: "view-flex view-flex-center"
  }, [_c('div', {
    staticClass: "member-card-avatar"
  }, [_c('img', {
    staticClass: "member-card-avatar-img",
    attrs: {
      "src": _vm.logo
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "appmsg"
  }, [_c('div', {
    staticClass: "appmsg-header"
  }, [_c('img', {
    staticClass: "appmsg-header-img",
    attrs: {
      "src": _vm.wximageurl + _vm.articals[0].thumb_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "appmsg-header-caption"
  }, [(_vm.articals[0].title != '') ? [_vm._v("\n                " + _vm._s(_vm.articals[0].title) + "\n              ")] : [_vm._v("\n                标题\n              ")]], 2)]), _vm._v(" "), _vm._l((_vm.articals), function(item, index) {
    return (index !== 0) ? _c('div', {
      staticClass: "appmsg-list"
    }, [_c('div', {
      staticClass: "appmsg-list-item"
    }, [_c('div', {
      staticClass: "appmsg-list-item-title"
    }, [(item.title != '') ? [_vm._v("\n                  " + _vm._s(item.title) + "\n                ")] : [_vm._v("\n                  标题\n                ")]], 2), _vm._v(" "), _c('div', {
      staticClass: "appmsg-list-item-thumb"
    }, [_c('img', {
      staticClass: "appmsg-list-item-thumb-img",
      attrs: {
        "src": _vm.wximageurl + item.thumb_url
      }
    })])])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "setting-view"
  }, [(_vm.data.news) ? _c('div', {
    staticClass: "msgSender_content"
  }, [_c('div', {
    staticClass: "msg msg-item has-first-cover",
    class: _vm.data.news.content.news_item.length > 1 ? 'multi' : 'single'
  }, [_c('div', {
    staticClass: "msg-content"
  }, [_c('div', {
    staticClass: "msg-info"
  }, [_c('span', [_vm._v("更新于 " + _vm._s(_vm._f("datetime")(_vm.data.news.content.update_time)))])]), _vm._v(" "), _c('div', {
    staticClass: "sub-msg-item",
    class: _vm.data.news.content.news_item.length > 1 ? 'coverMsgItem' : ''
  }, [_c('h4', {
    staticClass: "msg-title"
  }, [_c('a', [_vm._v(_vm._s(_vm.data.news.content.news_item[0].title))])]), _vm._v(" "), _c('div', {
    staticClass: "msg-thumb-wrap",
    style: ({
      backgroundImage: 'url(' + _vm.wximageurl + _vm.data.news.content.news_item[0].thumb_url + ')'
    })
  }), _vm._v(" "), _c('a', {
    staticClass: "edit-mask preview-mask",
    attrs: {
      "href": _vm.data.news.content.news_item[0].url
    }
  }, [_c('div', {
    staticClass: "edit-mask-content"
  }, [_vm._v("\n                  预览文章\n                ")])]), _vm._v(" "), (_vm.data.news.content.news_item.length === 1) ? _c('p', {
    staticClass: "msg-desc"
  }, [_vm._v(_vm._s(_vm.data.news.content.news_item[0].digest))]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.data.news.content.news_item), function(item, index) {
    return (index !== 0) ? _c('div', [(_vm.data.news.content.news_item.length > 1) ? _c('div', {
      staticClass: "article-msg-item has-cover clearfix"
    }, [_c('div', {
      staticClass: "msg-thumb-wrap",
      style: ({
        backgroundImage: 'url(' + _vm.wximageurl + item.thumb_url + ')'
      })
    }), _vm._v(" "), _c('h4', {
      staticClass: "msg-title"
    }, [_c('a', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('a', {
      staticClass: "edit-mask preview-mask",
      attrs: {
        "href": item.url
      }
    }, [_c('div', {
      staticClass: "edit-mask-content"
    }, [_vm._v("\n                    预览文章\n                  ")])])]) : _vm._e()]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "appmsg_preview_area"
  }, [_c('div', {
    staticClass: "appmsg_preview_container"
  }, [_c('div', {
    attrs: {
      "id": "submitContent"
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "appmsg_container_bd"
  }, [_c('div', {
    staticClass: "appmsg multi has_first_cover editing"
  }, [_c('div', {
    staticClass: "appmsg_content",
    attrs: {
      "id": "js_appmsg_preview"
    }
  }, [_vm._l((_vm.articals), function(item, index) {
    return [(index === 0) ? _c('div', {
      staticClass: "js_appmsg_item appmsg_item_wrp",
      class: _vm.id === index ? 'current' : '',
      on: {
        "click": function($event) {
          return _vm.handleClick(index)
        }
      }
    }, [_c('div', {
      staticClass: "first_appmsg_item",
      attrs: {
        "title": "第一篇图文"
      }
    }, [_c('div', {
      staticClass: "cover_appmsg_item"
    }, [_c('h4', {
      staticClass: "appmsg_title"
    }, [_c('a', {
      staticClass: "js_appmsg_title",
      attrs: {
        "href": "javascript:void(0);",
        "onclick": "return false;"
      }
    }, [(_vm.articals[0].title != '') ? [_vm._v("\n                                " + _vm._s(_vm.articals[0].title) + "\n                              ")] : [_vm._v("\n                                标题\n                              ")]], 2)]), _vm._v(" "), _c('div', {
      staticClass: "appmsg_thumb_wrp",
      style: ({
        backgroundImage: 'url(' + (item.thumb_url ? _vm.wximageurl + item.thumb_url : '') + ')'
      })
    }, [(!item.thumb_url) ? _c('div', {
      staticClass: "appmsg_thumb default"
    }, [_c('i', {
      staticClass: "icon_appmsg_thumb el-icon-picture"
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "appmsg_edit_mask"
    }, [_c('a', {
      staticClass: "icon20_common iconfont icon-arrow-down sort_down_white",
      attrs: {
        "onclick": "return false;",
        "title": "下移"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.sortdown(index)
        }
      }
    })])])]) : _c('div', {
      staticClass: "js_appmsg_item appmsg_item_wrp",
      class: _vm.id === index ? 'current' : '',
      on: {
        "click": function($event) {
          return _vm.handleClick(index)
        }
      }
    }, [_c('div', {
      staticClass: "appmsg_item has_cover"
    }, [_c('div', {
      staticClass: "appmsg_thumb_wrp",
      style: ({
        backgroundImage: 'url(' + (item.thumb_url ? _vm.wximageurl + item.thumb_url : '') + ')'
      })
    }, [(!item.thumb_url) ? _c('div', {
      staticClass: "appmsg_thumb default"
    }, [_c('i', {
      staticClass: "icon_appmsg_thumb_small el-icon-picture"
    })]) : _vm._e()]), _vm._v(" "), _c('h4', {
      staticClass: "appmsg_title js_appmsg_title"
    }, [(item.title != '') ? [_vm._v("\n                            " + _vm._s(item.title) + "\n                          ")] : [_vm._v("\n                            标题\n                          ")]], 2), _vm._v(" "), _c('div', {
      staticClass: "appmsg_edit_mask"
    }, [_c('a', {
      staticClass: "icon20_common sort_up_white iconfont icon-arrow-up",
      attrs: {
        "title": "上移"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.sortup(index)
        }
      }
    }), _vm._v(" "), (index !== (_vm.articals.length - 1)) ? _c('a', {
      staticClass: "icon20_common sort_down_white iconfont icon-arrow-down",
      attrs: {
        "title": "下移"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.sortdown(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('el-popover', {
      attrs: {
        "placement": "bottom",
        "width": "220",
        "trigger": "click"
      },
      model: {
        value: (item.popVisible),
        callback: function($$v) {
          _vm.$set(item, "popVisible", $$v)
        },
        expression: "item.popVisible"
      }
    }, [_c('p', {
      staticClass: "content-padded content-center",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("确定删除这篇文章？")]), _vm._v(" "), _c('div', {
      staticClass: "content-center"
    }, [_c('el-button', {
      on: {
        "click": function($event) {
          item.popVisible = false
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.remove(index)
        }
      }
    }, [_vm._v("确定")])], 1), _vm._v(" "), (!_vm.isEditting) ? _c('a', {
      staticClass: "icon20_common del_media_white el-icon-delete",
      attrs: {
        "slot": "reference",
        "title": "删除"
      },
      slot: "reference"
    }) : _vm._e()])], 1)])])]
  })], 2)]), _vm._v(" "), (!_vm.isEditting) ? _c('div', {
    staticClass: "create_access_primary appmsg_add",
    attrs: {
      "title": "添加一篇图文"
    },
    on: {
      "click": _vm.addmsg
    }
  }, [_c('i', {
    staticClass: "icon35_common el-icon-plus"
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "appmsg_input_area"
  }, [_vm._l((_vm.articals), function(item, index) {
    return (_vm.id === index) ? [_c('el-form', {
      ref: "item",
      refInFor: true,
      attrs: {
        "model": item,
        "label-position": "top",
        "label-width": "80px"
      }
    }, [_c('div', {
      staticClass: "content-padded"
    }, [_c('el-form-item', {
      staticStyle: {
        "height": "80px"
      },
      attrs: {
        "label": "标题"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入标题"
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "height": "380px"
      }
    }, [_c('vue-html5-editor', {
      ref: "editor",
      refInFor: true,
      attrs: {
        "content": item.viewcontent,
        "id": index,
        "height": 360
      },
      on: {
        "change": _vm.updateContent
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "content-padded appmsg_edit_highlight_area",
      staticStyle: {
        "height": "420px"
      }
    }, [_c('h3', {
      staticClass: "header-title"
    }, [_vm._v("发布样式编辑")]), _vm._v(" "), _c('div', {
      staticClass: "header_tips"
    }, [_vm._v("封面小图片 "), _c('span', {
      staticClass: "form-text-tip"
    }, [_vm._v("建议尺寸：200像素 * 200像素")])]), _vm._v(" "), _c('el-form-item', [_c('div', [_c('el-button', {
      on: {
        "click": _vm.addThumbPreview
      }
    }, [_vm._v("从图片库选择")])], 1), _vm._v(" "), (item.thumb_url) ? _c('div', {
      staticClass: "cover_preview",
      style: ({
        backgroundImage: 'url(' + (item.thumb_url ? _vm.wximageurl + item.thumb_url : '') + ')'
      })
    }) : _vm._e()])], 1)])] : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "appmsg_tpl_area"
  }, [_c('div', {
    staticClass: "appmsg_tpl_container"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "appmsg_container_bd"
  }, [_c('ul', {
    staticClass: "tpl_list",
    attrs: {
      "id": "js_media_list"
    }
  }, [_c('li', {
    staticClass: "tpl_item img",
    on: {
      "click": _vm.addImgPreview
    }
  }, [_c('i', {
    staticClass: "iconfont icon-image"
  }), _vm._v("图片\n                ")])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  }), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-flex view-flex-middle view-flex-item"
  }, [_c('div', [_vm._v("主题：")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "theme-item",
    staticStyle: {
      "background": "#fff"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-flex view-flex-center view-flex-item view-flex-vertical"
  }, [_c('div', {
    staticClass: "store-name"
  }, [_vm._v("源源客")]), _vm._v(" "), _c('div', {
    staticClass: "level-name"
  }, [_vm._v("源源客会员卡")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-flex view-flex-right"
  }, [_c('div', {
    staticClass: "member-card-level"
  }, [_c('div', {
    staticClass: "member-card-level-num"
  }), _vm._v(" "), _c('div', {
    staticClass: "member-card-level-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "member-card-level-tip"
  }, [_vm._v("还差100元升级为白金会员")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white member-coupon"
  }, [_c('div', {
    staticClass: "view-flex view-flex-center view-flex-middle code-toggle"
  }, [_c('img', {
    staticClass: "code-toggle-img",
    attrs: {
      "src": "/static/img/qr_code.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "item-icon",
    attrs: {
      "src": "/static/img/icon_down.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section-title content-center"
  }, [_vm._v("我的资产")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('div', {
    staticClass: "view-flex content-center member-coupon-wrapper"
  }, [_c('div', {
    staticClass: "view-flex-item view-flex-vertical member-coupon-item"
  }, [_c('div', [_vm._v("¥ 122.00")]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "member-coupon-icons",
    attrs: {
      "src": "/static/img/icon_01.png"
    }
  }), _vm._v(" 储值")])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item view-flex-vertical member-coupon-item"
  }, [_c('div', [_vm._v("6 张")]), _vm._v(" "), _c('div', [_c('img', {
    staticClass: "member-coupon-icons",
    attrs: {
      "src": "/static/img/icon_02.png"
    }
  }), _vm._v(" 优惠券")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white nearly-store"
  }, [_c('div', {
    staticClass: "section-header content-center"
  }, [_vm._v("附近门店")]), _vm._v(" "), _c('div', {
    staticClass: "section-body view-flex nearly-store-info"
  }, [_c('div', {
    staticClass: "view-flex-item info-content"
  }, [_c('div', {
    staticClass: "store-name"
  }, [_vm._v("商派软件有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "store-address"
  }, [_vm._v("上海市徐汇区田林路396号2号楼")]), _vm._v(" "), _c('div', {
    staticClass: "store-open-time"
  }, [_vm._v("营业时间：9:30 - 18:30")])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex view-flex-vertical view-flex-middle store-location"
  }, [_c('img', {
    staticClass: "store-location-img",
    attrs: {
      "src": "/static/img/icon_location.png"
    }
  }), _vm._v("12km")])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex view-flex-middle view-flex-right section-footer with-border content-right"
  }, [_vm._v("全部门店 "), _c('img', {
    staticClass: "icon-to-all",
    attrs: {
      "src": "/static/img/icon_to.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appmsg_container_hd"
  }, [_c('h4', {
    staticClass: "appmsg_container_title"
  }, [_vm._v("小程序营销文章配置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appmsg_container_hd"
  }, [_c('h4', {
    staticClass: "appmsg_container_title"
  }, [_vm._v("多媒体")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37cba140", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37cba140"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/template/store/default.vue
// module id = 2616
// module chunks = 0